<template>
  <div class="comp-banner-list">
    <el-carousel :height="height">
      <el-carousel-item v-for="(item, i) in data" :key="i">
        <a @click="handleClick(item)" target="_blank">
          <div
            class="carouse_img"
            :style="
              `height: ${height};background-size: 1920px ${height};background-image: url(${item.Banner});`
            "
          >
            <!-- <span>{{ item.Address }}</span> -->
          </div>
        </a>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "ic-banner-list",
  props: {
    data: {
      type: Array
    },
    height: {
      type: String,
      default: "380px"
    }
  },
  methods: {
    handleClick(item) {
      window.open(item.Address, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.carouse_item {
  width: 100%;
  text-align: center;
  cursor: pointer;
}
.carouse_img {
  background-repeat: no-repeat;
  background-position: 50% 50%;
  // background-image:url("/img/home/banner.png");
  // background: url("/img/home/banner.png") no-repeat center center;
}
.comp-banner-list {
  ::v-deep .el-carousel {
    margin: 0 auto;
    text-align: center;
  }
  ::v-deep .el-carousel__button {
    height: 6px;
    opacity: 1;
  }
  ::v-deep .el-carousel__item {
    img {
      height: 100%;
      width: auto;
    }
  }
  ::v-deep .el-carousel__button {
    border-radius: 3px;
  }
  ::v-deep .el-carousel__indicator.is-active {
    .el-carousel__button {
      background-color: $primary-color;
    }
  }
}
</style>
